import {httpService} from "@/modules/core/services/http-service";
import {Gemeente} from "@/modules/gemeente/domain";


export async function getAlleGemeentes(): Promise<Gemeente[]> {
    const response = await httpService.get<any>(`/api/gemeente/all?sort=postcode`);
    return response.map((municipality: any) => new Gemeente(municipality))
}